import { LoggingService } from './core/services/logging.service';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './core/services/error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private readonly injector: Injector ) { }

  handleError(error: HttpErrorResponse) {
    console.error('Global error handler caught an error:', error);
    const errorService = this.injector.get(ErrorService);
    const logger = this.injector.get(LoggingService);
    let message;
    let status;
    errorService.hideToastr();
    if (error instanceof HttpErrorResponse) {
      // Server error
      message = errorService.getServerErrorMessage(error);
      status = error.status;
    } else {
      // Client Error
      message = "Page not found.";
      status = 404;
    }
    errorService.handleError(error);
    logger.logError(error);
  }
}
